module.exports = __webpack_public_path__ + "img/mirror10.5716a7e9.jpg";